import HTTPClientCache from "./http-client_cache";

// Override `maxAge` and cache URLs with query parameters
const options = {
  cache: {
      // maxAge: 1 * 60 * 60 * 1000, // set cache time to 1 hour (instead 15 minutes)
      exclude: { query: false } // cache requests with query parameters
  }
}

class CountiesService {
  async getAllCounties() {
    const httpClient = new HTTPClientCache();
    const api = await httpClient.configure();
    return api.get(`/copelcities`, options);
  }

  async getCountie(id) {
    const httpClient = new HTTPClientCache();
    const api = await httpClient.configure();
    return api.get(`/copelcity/${id}`, options);
  }

}

export default new CountiesService();
